<ion-app>
  <in2-menu contentId="main-content"></in2-menu>
  <ion-router-outlet id="main-content"></ion-router-outlet>
</ion-app>
